@use "../../../design-tokens/border-radius/border-radius" as *;
@use "../../../design-tokens/typography/typography" as *;

@layer design-system {
  .dropdownWrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .dropdownGroup {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .dropdownItemButton {
    margin: 0 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    @include border-radius-r1;

    &:not(.disabled) {
      cursor: pointer;
    }
  }

  .dropdownMenuItem {
    all: unset;

    &[data-highlighted] {
      .dropdownItemButton {
        background-color: var(--surface-hover);
      }
    }

    &[data-disabled] {
      .dropdownItemButton {
        color: var(--text-disabled);
      }

      .dropdownIcon {
        fill: var(--icon-disabled);
      }
    }
  }

  .dropdownItemLabel {
    @include typography-v2-body-sm;
  }

  .separator {
    height: 1px;
    background-color: var(--border-soft);
  }
}
